// src/components/ui/DeleteModal.jsx
import React from "react";

export default function DeleteModal({ show, onClose, onConfirm, itemName, loading = false }) {
  if (!show) return null;
  return (
    <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,.55)" }} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 420 }}>
        <div className="modal-content" style={{ borderRadius: 16 }}>
          <div className="modal-body text-center p-4">
            <div className="delete-confirm-icon">
              <i className="bi bi-trash3" />
            </div>
            <h5 style={{ fontWeight: 700, color: "var(--gray-800)", marginBottom: 8 }}>
              Confirmar Exclusão
            </h5>
            <p style={{ color: "var(--gray-500)", fontSize: 14, marginBottom: 0 }}>
              Tem certeza que deseja excluir o condomínio{" "}
              <strong style={{ color: "var(--gray-700)" }}>{itemName}</strong>?
              <br />
              <span style={{ fontSize: 12.5, color: "var(--gray-400)" }}>
                Essa ação não poderá ser desfeita.
              </span>
            </p>
          </div>
          <div className="modal-footer border-0 justify-content-center gap-3 pb-4">
            <button className="btn btn-outline-secondary px-4" onClick={onClose}>
              <i className="bi bi-x-circle me-2" />Cancelar
            </button>
            <button
              className="btn btn-danger px-4"
              style={{ fontFamily: "Poppins, sans-serif", fontWeight: 500 }}
              onClick={onConfirm}
              disabled={loading}
            >
              {loading
                ? <><span className="spinner-border spinner-border-sm me-2" />Excluindo...</>
                : <><i className="bi bi-trash3 me-2" />Excluir</>
              }
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
